import { BlankSlate, Box, Button } from '@factorialco/deprecated-design-system'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  error?: boolean
}

interface Info {
  title: string
  description: string
  icon: 'sign-post' | 'send-email-envelope'
  help_center?: string
}

const Overview = ({ error }: Props) => {
  const { navigation } = useNavigation()

  const { title, description, icon, help_center }: Info = error
    ? {
        title: i18n.t('ats.messages.no_conversation.error.title'),
        description: i18n.t('ats.messages.no_conversation.error.description'),
        icon: 'sign-post',
      }
    : {
        title: i18n.t('ats.messages.no_conversation.title'),
        description: i18n.t('ats.messages.no_conversation.description'),
        icon: 'send-email-envelope',
        help_center: i18n.t('ats.messages.no_conversation.more_information'),
      }

  return (
    <BlankSlate illustration={icon} title={title} description={description} size="small">
      <Box gap="s24" alignItems="center">
        <Box flexDirection="row" gap="s8">
          <Button.Router to={navigation.ats.jobs.fullPath()}>
            {i18n.t('ats.messages.no_conversation.go_to_jobs')}
          </Button.Router>
          <Button.Router type="secondary" to={navigation.settings.ats.templates.fullPath()}>
            {i18n.t('ats.messages.edit_templates')}
          </Button.Router>
        </Box>
        {help_center && <HelpCenterLink name="ats_message_board">{help_center}</HelpCenterLink>}
      </Box>
    </BlankSlate>
  )
}

export default Overview
